


















import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop, Emit, Watch } from "vue-property-decorator";

@Component
export default class WQtypeTextView extends BaseComponent {
	@Prop({ type: Object, required: true })
	options!: any;
	@Prop()
	injectedAnswer!: any;
	@Prop()
	injectedStats!: any;
	@Prop({ type: Boolean, default: false })
	lock!: boolean;

	answerValue = (this.injectedAnswer || { value: "" }).value;

	get form() {
		let attrs: any = {
			autocomplete: "off"
		};

		attrs["minlength"] = this.options.min;

		if (this.options.max) {
			attrs["maxlength"] = this.options.max;
		}

		return {
			fields: {
				answer: {
					field: "textarea",
					i18n: { placeholder: "SX_LANG_WRITE" },
					attrs
				}
			}
		};
	}

	get stats() {
		if (this.injectedStats) {
			let total = this.injectedStats.questionAnswersCount,
				totalEmpty = this.injectedStats.questionAnswersEmptyCount,
				totalNoEmpty = total - totalEmpty,
				percent =
					parseInt(String((totalNoEmpty / (total || 1)) * 10000)) /
					100;

			return {
				total,
				totalEmpty,
				totalNoEmpty,
				percent
			};
		}
		return {};
	}
	@Watch("answerValue")
	watchAnswerValue() {
		this.onAnswerChange();
	}

	@Emit("type-answer-change")
	onAnswerChange() {
		let min = this.options.min,
			max = this.options.max,
			len = this.answerValue ? this.answerValue.length : 0,
			valid = true;

		if (len) {
			valid = min <= len && (max ? len <= max : true);
		}

		return {
			value: this.answerValue,
			isValid: valid,
			isEmpty: !len
		};
	}

	mounted() {
		this.onAnswerChange();
	}
}
